import {ALL, USR_INSP, MISC_IMG, LANG_V2, LANG_CATS, LANG_RELS, REP_TYPES}  from '../../Data/typeDirs'
import typeMap from '../../Data/typeMap'

const typeDirs = [...ALL, USR_INSP, MISC_IMG, LANG_V2, ...LANG_CATS, ...LANG_RELS, ...REP_TYPES]
const sources = {}
const stdMethods = ['get', 'put', 'kill', 'toArray', 'toFlatArray']

class DataSource {
  constructor(props) {
    const localStdMethods = []
    // console.log(props)
    for (const propName in props) {
      const prop = props[propName]
      if (stdMethods.includes(propName)) localStdMethods.push(propName)
      this._addDataMethod(propName, prop.bind(this))
    }
    if (localStdMethods.length < stdMethods.length) {
      const lsmStr = localStdMethods.join(', ')
      const smStr = stdMethods.join(', ')
      const exp = `have ${lsmStr}; expect ${smStr}`
      const errText = `Cannot initialize DataSource, lacking a basic method (${exp})`
      throw new Error(errText)
    }
  }

  getDataMethods(dir = '') {
    // if specific type dir is provided, return it
    // console.log('asked for dir', dir)
    // console.log(this)
    // console.log(this.dir)
    if (this[dir]) return this[dir]
    // if an empty string is provided, return the methods of the first typeDir
    // (since they'll all be the same anyway)
    if (dir === '') {
      const [firstObjectName] = typeDirs
      return this.getDataMethods(firstObjectName)
    }
  }

  _addDataMethod(type, fn) {
    // Iterate through all typeDirs (i.e. inspection_store, reports,
    // collections) and add all of own methods to each typeDir to emulate dexie
    // API
    for( const typeDirName in typeDirs ){
      // console.log('INIT DS FOR', typeDirs[typeDirName])
      if( typeDirName === 'urlVarMap' ) continue
      else {
        const typeDir = typeDirs[typeDirName]
        this[typeDir] = this[typeDir] || {}
        this[typeDir][type] = (args, usr) => fn(typeDir, args, usr)
        // console.log('ADDED FUNCTION TO DS', this[typeDir], type)

        if( type === 'get' && typeMap[typeDir]){
          this[typeDir]['getTyped'] = async args => {
            // console.log('in GetTyped', args)
            const res = await fn(typeDir, args)
            // console.log('got res', res)
            const MyClass = typeMap[typeDir]
            // console.log('made myClass', MyClass, typeMap, typeDir)
            return new MyClass(res)
          }
        }
        if (type === 'toArray') {
          this[typeDir]['toTypedArray'] = async (...args) => {
            // console.log('to typed array with args', args, fn)
            const res = await fn(typeDir, ...args)
            const MyClass = typeMap[typeDir]
            return res.map((itm) => new MyClass(itm))
          }
        }
      }
    }
  }
}

export const addDataSource = function (type, props) {
  const ds = new DataSource(props)
  // console.log(ds, type, props)
  sources[type] = ds
}

// Merges the results of two returns from different dataSources
const mergeTwoFileResults = function (res1, res2) {
  if (!res1) return res2
  if (!res2) return res1
  if (Array.isArray(res1) && Array.isArray(res2)) {
    let res = []
    let rem = []
    // console.log('merging', res1, res2)
    // for( const item1 of res1 ){
    //
    // }
    for (const item1 of res1) {
      // console.log('looking at item of res1', item1)
      const [item2] = res2.filter((elm) => elm._id === item1._id)
      // console.log('found equivalent item in res2', item2)
      if (item2) {
        if (item2._loaded) {
          // console.log('res2 item is newer, pushing it')
          res.push(item2)
        } else {
          // console.log('original item is newer, pushing it')
          res.push(item1)
        }
        // console.log('shrinking remainder')
        rem = res2.filter((elm) => elm._id !== item1._id)
        console.log(rem)
      } else {
        res.push(item1)
        // console.log('could not find equivalent item, pushing oriignal')
      }
    }
    if (rem.length) {
      for (const item of rem) {
        const [item2] = res.filter((elm) => elm._id === item._id)
        if (!item2) res.push(item)
      }
    }
    // console.log('final result', res)
    return res
  } else if (res1._id && res2._id) {
    if (res1._loaded) {
      return res1
    } else {
      return res2
    }
  } else
    throw new Error(
      `DataSource.mergeFileResults: merging two different result types`,
    )
}

// Merges the results of all returns from different dataSources
const mergeAllFileResults = function (allRes) {
  // console.log('merging all results', allRes)
  let [first, second] = allRes
  let theRest = allRes.slice(2)
  let res = mergeTwoFileResults(first, second)
  for (const fileRes of theRest) {
    res = mergeTwoFileResults(res, fileRes)
  }
  // console.log('returning merged', res)
  return res
}

// Allows one to run a method against one or multiple data sources
const _dataSource = function (...dataSourceTypes) {
  let res = {}
  if (dataSourceTypes.length === 1) {
    return sources[[dataSourceTypes]]
  }
  for (let dataSourceType of dataSourceTypes) {
    // console.log('datasourceType', dataSourceType)
    const ds = sources[dataSourceType]
    if (ds) {
      for (const type of typeDirs) {
        res[type] = res[type] || {}
        const theseMethods = ds.getDataMethods(type)
        for (const methodName of Object.keys(theseMethods)) {
          const method = theseMethods[methodName]
          if (!res[type][methodName]) {
            res[type][methodName] = async function (...args) {
              const appRes = await method.apply(null, args)
              // console.log(`run ${type} ${methodName} with rez`, res)
              return [appRes]
            }
          } else {
            const oldFn = res[type][methodName]
            res[type][methodName] = async function (...args) {
              const firstRes = await oldFn.apply(null, args)
              const secondRes = await method.apply(null, args)
              // console.log(`run secondary ${type} ${methodName} with rezzes`, firstRes, secondRes)
              const finalRes = [...firstRes, secondRes]
              finalRes.merge = function () {
                return mergeAllFileResults(finalRes)
              }
              return finalRes
            }
          }
        }
      }
    }
  }
  return res
}

_dataSource.merge = mergeAllFileResults
export const dataSource = _dataSource
